/** Displays issue types a user is most often assigned to (from API assignment_focus). */
export function formatAssignmentFocus(labels) {
  if (!labels?.length) return null;
  return labels.join(", ");
}

export default function AssignmentFocus({
  labels,
  className = "",
  emptyClassName = "text-xs text-gray-400",
  emptyText = "No assignments yet",
}) {
  const text = formatAssignmentFocus(labels);
  if (!text) {
    return <span className={emptyClassName}>{emptyText}</span>;
  }
  return (
    <span className={className} data-testid="assignment-focus">
      {text}
    </span>
  );
}
